var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Clock"),React.createElement("g",{"fill":"#fff","className":"nc-icon-wrapper","key":1},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.03 3.344a13.006 13.006 0 0 1 5.94 0 7.63 7.63 0 0 1 5.686 5.686 13.008 13.008 0 0 1 0 5.94 7.63 7.63 0 0 1-5.686 5.686 13.008 13.008 0 0 1-5.94 0 7.63 7.63 0 0 1-5.686-5.686 13.006 13.006 0 0 1 0-5.94A7.63 7.63 0 0 1 9.03 3.344zm3.246 5.784a.6.6 0 1 0-1.2 0v3.536a.6.6 0 0 0 .278.507l2.717 1.728a.6.6 0 1 0 .644-1.012l-2.44-1.552V9.128z","fill":"#fff"}))]);
}

Clock.defaultProps = {"width":"49","height":"49","viewBox":"0 0 24 24"};

module.exports = Clock;

Clock.default = Clock;
